import { jsxs, jsx } from "react/jsx-runtime";
const IconStairsSvg = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ jsxs(
  "svg",
  {
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    fill: "currentColor",
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M21.024 2c.54 0 .976.437.976.976v18.048a.976.976 0 0 1-.976.976H2.976A.976.976 0 0 1 2 21.024v-6.016c0-.539.437-.976.976-.976h4.878v-5.04c0-.539.436-.975.975-.975h5.366V2.976c0-.54.437-.976.976-.976h5.853Zm-4.878 6.992a.976.976 0 0 1-.975.976H9.805v5.04a.976.976 0 0 1-.976.975H3.951v4.066H20.05V3.95h-3.903v5.041Z" })
    ]
  }
);
export {
  IconStairsSvg
};
